import utils from 'utils'

class goodsStatisticsCtrl {
    constructor($scope, httpRequest, $state, initSortService, logger) {
        $scope.orgList=[]
        function init() {
            $scope.storageName = 'goodsStatisticsParam'

            const {
                firstDate,
                lastDate,
            } = utils.getMonthFirstLast()

            // 初始queryParam.param

            // 有缓存参数，从缓存中取orgId，没有就取当前机构
            const currentOrgId = (sessionStorage[$scope.storageName] ? JSON.parse(sessionStorage[$scope.storageName]).param.orgId : JSON.parse(localStorage.user_info).user.currentOrgId)+''
            $scope.defaultParam = {
                beginTime: firstDate,
                endTime: lastDate,
                goodsName: '',
                orgId: currentOrgId,
            }
            // 查询参数
            $scope.queryParam = sessionStorage[$scope.storageName] ? JSON.parse(sessionStorage[$scope.storageName]) : {
                pageNumber: 1,
                pageSize: 10,
                orderMap: {},
                param: {
                    ...$scope.defaultParam,
                },
            }


            function getOrgList() {
                httpRequest.get_getUserOrgList().then((res) => {
                    $scope.orgList = res.data.value
                })
            }
            getOrgList()

            $scope.orderMap = initSortService($scope.storageName)

            $scope.totalStatis = {
                amount: '0.00',
                taxAmount: '0.00',
                adValoremTotal: '0.00',
                invoiceNum: '0',
            }
        }
        init()

        $scope.reset = function reset() {
            $scope.queryParam.param = {
                ...$scope.defaultParam,
            }
        }
        
        $scope.queryGoodsList = function queryGoodsList() {
            httpRequest.post_queryGoogdStatisticsList($scope.queryParam).then((res) => {
                $scope.listData = res.data.value.list
                $scope.totalItems = res.data.value.total
                $scope.queryParam.pageNum = res.data.value.pageNum
                $scope.listData.forEach((item) => {
                    if (item.quantity !== null && item.quantity !== undefined) {
                        item.quantity = parseFloat(item.quantity)
                    }
                })
            }, () => {
                $scope.listData = []
                $scope.totalItems = 0
            })
            httpRequest.post_statisticsGoodsList($scope.queryParam.param).then((res) => {
                if (res.data.value) {
                    $scope.totalStatis = res.data.value
                } else {
                    $scope.totalStatis = {
                        amount: '0.00',
                        taxAmount: '0.00',
                        adValoremTotal: '0.00',
                        invoiceNum: '0',
                    }
                }
            }, () => {
                $scope.totalStatis = {
                    amount: '0.00',
                    taxAmount: '0.00',
                    adValoremTotal: '0.00',
                    invoiceNum: '0',
                }
            })
        }

        $scope.selectedHandle = function selectedHandle() {
            $scope.queryParam.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.queryParam.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            sessionStorage.setItem($scope.storageName, JSON.stringify($scope.queryParam))
            $scope.queryGoodsList()
        }

        $scope.pageChanged = function pageChanged() {
            sessionStorage.setItem($scope.storageName, JSON.stringify({
                orderMap: $scope.queryParam.orderMap,
                pageNum: $scope.queryParam.pageNum,
                pageSize: $scope.queryParam.pageSize,
                param: sessionStorage[$scope.storageName] ? JSON.parse(sessionStorage[$scope.storageName]).param : {
                    ...$scope.defaultParam,
                },
            }))
            $scope.queryGoodsList()
        }

        $scope.searchlist = function searchlist() {
            if (overOneYear($scope.queryParam.param.endTime, $scope.queryParam.param.beginTime)) {
                logger.logError('[开票日期]起始结束时间跨度不能超过一年')
                return
            }
            sessionStorage.setItem($scope.storageName, JSON.stringify($scope.queryParam))
            $scope.queryGoodsList()
        }

        $scope.toRelInvList = function toRelInvList(item) {
            const obj = {
                goods: item,
                param: $scope.queryParam.param,
            }
            localStorage.setItem('goodsStatisticsRelatedInvoice', JSON.stringify(obj))
            $state.go('statistics.inputStatistics.goodsStatistics.relatedInvoice')
        }

        $scope.$on('$stateChangeStart', (e, toState) => {
            if (toState.name.indexOf('statistics.inputStatistics.goodsStatistics') == -1) {
                sessionStorage.removeItem($scope.storageName)
            }
        })

        $scope.exportExel = function exportExel() {
            if ($scope.totalItems > 50000) {
                logger.logError('一次最多导出５万条数据，请缩小查询范围！')
                return
            }

            const reqObj = $.extend({
                accessToken: localStorage.id_token,
            }, $scope.queryParam.param)
            for (let i in $scope.queryParam.orderMap) {
                reqObj.sortField = i + ':' + $scope.queryParam.orderMap[i]
            }
            httpRequest.get_exportStatisticsGoods(reqObj)
        }

        if (sessionStorage[$scope.storageName]) $scope.queryGoodsList() // 默认不查询

        function overOneYear(max, min) {
            const dateMaxTmp = new Date(max)
            const dateMinTmp = new Date(min)

            const dateMaxYear = dateMaxTmp.getFullYear()
            const dateMaxMonth = dateMaxTmp.getMonth()
            const dateMaxDay = dateMaxTmp.getDate()

            const dateMinYear = dateMinTmp.getFullYear()
            const dateMinMonth = dateMinTmp.getMonth()
            const dateMinDay = dateMinTmp.getDate()

            return (dateMaxYear - dateMinYear > 1) || (dateMaxYear - dateMinYear === 1) && (dateMaxMonth - dateMinMonth > 0) || ((dateMaxYear - dateMinYear > 0) && (dateMaxMonth - dateMinMonth === 0) && (dateMaxDay - dateMinDay > -1))
        }
    }
}
goodsStatisticsCtrl.$inject = ['$scope', 'httpRequest', '$state', 'initSortService', 'logger']
export default goodsStatisticsCtrl



// WEBPACK FOOTER //
// ./src/app/statistics/inputStatistics/goodsStatistics/goodsStatisticsListCtrl.js